import { render, staticRenderFns } from "./TabsList.vue?vue&type=template&id=b2f023be&"
var script = {}
import style0 from "./TabsList.vue?vue&type=style&index=0&id=b2f023be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports